import React, { useState, useEffect } from 'react';

import ActionButtons from '../../components/ActionButtons';

import { firestoreRongve } from '../../firebase';

export default function RongveRemoveCoach(props) {
    const [users, setUsers] = useState([]);
    const [searchInput, setSearchInput] = useState('');

    const fetchUsers = async () => {
        const usersRef = firestoreRongve.collection("users");
        const snapshot = await usersRef.get();
        const userList = [];
        snapshot.forEach(doc => {
            const userData = doc.data();
            if (userData.trainer === true) {
                userList.push({ id: doc.id, ...userData });
            }
        });
        setUsers(userList);
    };

    const removeTrainer = async (userId) => {
        await firestoreRongve.collection("users").doc(userId).update({ trainer: false });
        fetchUsers();
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const filteredUsers = users.filter(user => user.name.toLowerCase().includes(searchInput.toLowerCase()));

    return (
        <div>
            <h3>Søk og velg en trener for å fjerne dem</h3>
            <input
                type="text"
                className="form-control mb-2"
                placeholder="Søk trener"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
            />
            {filteredUsers.map(user => (
                <div key={user.id} className="mb-2">
                    <button className="btn btn-danger me-2 d-inline" onClick={() => removeTrainer(user.id)}>Fjern trener</button>
                    <p className="d-inline">{user.name}</p>
                </div>
            ))}
            <ActionButtons setActive={props.setActive} />
        </div>
    );
}